const ACTION_SELECTOR =
  '[data-perf-action], button, a, input, textarea, select';

/** Use the same nearest-control attribution for input lag and interaction windows. */
export function getInputActionElement(
  target: EventTarget | null
): Element | null {
  return target instanceof Element ? target.closest(ACTION_SELECTOR) : null;
}
